/* tslint:disable */
/* eslint-disable */
/* @relayHash 24fe36260d6b34215a1792f841272f42 */

import { ConcreteRequest } from "relay-runtime";
export type InterviewNotesInput = {
    yourName: string;
    employmentDecider: string;
    interviewNotes: string;
    interviewNotesUploadToken?: string | null;
};
export type InterviewNotesModal_SubmitMutationVariables = {
    token: string;
    input: InterviewNotesInput;
};
export type InterviewNotesModal_SubmitMutationResponse = {
    readonly submitInterviewNotes: boolean;
};
export type InterviewNotesModal_SubmitMutation = {
    readonly response: InterviewNotesModal_SubmitMutationResponse;
    readonly variables: InterviewNotesModal_SubmitMutationVariables;
};



/*
mutation InterviewNotesModal_SubmitMutation(
  $token: String!
  $input: InterviewNotesInput!
) {
  submitInterviewNotes(token: $token, input: $input)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "token",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "InterviewNotesInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "submitInterviewNotes",
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                },
                {
                    "kind": "Variable",
                    "name": "token",
                    "variableName": "token"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "InterviewNotesModal_SubmitMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "InterviewNotesModal_SubmitMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "InterviewNotesModal_SubmitMutation",
            "id": null,
            "text": "mutation InterviewNotesModal_SubmitMutation(\n  $token: String!\n  $input: InterviewNotesInput!\n) {\n  submitInterviewNotes(token: $token, input: $input)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '4fb311a047e974224edadc873d4e34e6';
export default node;
